<!--设备管理-协议管理 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ProtocolManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox clearfix">
          <el-input class="searchInput" placeholder="请输入协议名称" v-model="protocalData.paging.protocal_name" clearable></el-input>
          <el-input class="searchInput" placeholder="请输入协议类型" v-model="protocalData.paging.protocal_type" clearable></el-input>
          <el-input class="searchInput" placeholder="请输入方向" v-model="protocalData.paging.direction" clearable></el-input>
          <el-select v-model="protocalData.paging.status" class="searchInput" placeholder="请选择状态" clearable>
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
          </el-select>
          <el-button class="searchBtn" type="primary" @click="getProtocalList('search')">搜索</el-button>
        </div>

        <!-- 添加按钮 -->
        <div class="addButton">
          <el-button type="primary" @click="operateDialogInfo('add')">添加</el-button>
        </div>

        <!-- 协议列表 -->
         <el-table
          v-loading="protocalData.loading"
          :data="protocalData.list"
          style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="功能说明：">
                  <span>{{ props.row.desc }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            label="协议名称"
            prop="protocal_name">
          </el-table-column>
          <el-table-column
            label="协议类型"
            prop="protocal_type"
            sortable>
          </el-table-column>
          <el-table-column
            label="方向"
            prop="direction"
            sortable>
          </el-table-column>
          <el-table-column
            label="前导符"
            prop="prefix_char"
            width="200"
            show-overflow-tooltip
            sortable>
          </el-table-column>
          <el-table-column
            label="功能码"
            prop="function_code"
            sortable
            width="90">
          </el-table-column>
          <el-table-column
            label="子功能码"
            prop="child_function_code"
            sortable
            width="100">
          </el-table-column>
          <el-table-column
            label="数据域长度"
            prop="data_length">
              <template slot-scope="scope">
                {{scope.row.data_length === '' ? '/' : scope.row.data_length}}
              </template>
          </el-table-column>
          <el-table-column
            label="数据域"
            prop="data"
            show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.data === '' ? '/' : scope.row.data}}
              </template>
          </el-table-column>
          <el-table-column
            label="BCC码"
            prop="bbc">
              <template slot-scope="scope">
                {{scope.row.bbc === '' ? '/' : scope.row.bbc}}
              </template>
          </el-table-column>
          <el-table-column
            label="状态"
            class-name="operate"
            width="60">
            <template slot-scope="scope">
              <el-button class="text" type="text" @click="operateDialogInfo('changeStatus', scope.row)">{{scope.row.status === '1' ? '启用' : '禁用'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            class-name="operate"
            width="60">
            <template slot-scope="scope">
              <el-button class="text" type="text" @click="operateDialogInfo('alter', scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging" v-if="protocalData.list.length !== 0">
          <el-pagination
            @size-change="sizeChange"
            @current-change="pageChange"
            :current-page.sync="protocalData.paging.page"
            :page-sizes="[10, 100, 1000]"
            :page-size.sync="protocalData.paging.perPage"
            layout="sizes, prev, pager, next"
            :page-count="protocalData.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 状态 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'changeStatus'">
            <p class="text">
              当前协议状态为
              <span class="bold">
                {{dialogData.info.status === '1' ? '启用' : '禁用'}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.status === '1' ? '禁用' : '启用'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeStatus()">{{dialogData.info.status === '1' ? '禁用' : '启用'}}</el-button>
            </div>
          </div>

          <!-- 添加或修改客户信息 -->
          <div v-else>
            <el-form
              class="updataForm"
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="协议名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.protocal_name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="协议类型:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.protocal_type"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="方向:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.direction"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="前导符:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.prefix_char"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="功能码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.function_code"></el-input>
                </div>
                <span class="hint">(功能码能重复，功能码+子功能码 不能重复)</span>
              </el-form-item>
              <el-form-item label="子功能码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.child_function_code"></el-input>
                  <span class="hint">(子功能码能重复，功能码+子功能码 不能重复)</span>
                </div>
              </el-form-item>
              <el-form-item label="数据域长度:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.data_length"></el-input>
                  <span class="hint">(非必填)</span>
                </div>
              </el-form-item>
              <el-form-item label="数据域:">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" :rows="3" v-model="dialogData.info.data"></el-input>
                  <span class="hint">(非必填)</span>
                </div>
              </el-form-item>
              <el-form-item label="BCC码:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.bbc"></el-input>
                  <span class="hint">(非必填)</span>
                </div>
              </el-form-item>
              <el-form-item label="功能说明:">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" :rows="3" v-model="dialogData.info.desc"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateProtocal()">确 认</el-button>
            </div>
          </div>
        </el-dialog>

      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { 
      showToast,
      storage,
      deepCopy
    } from "../../../../static/js/utility/utility.js"
  import { deviceApi } from "../../../../static/js/api.js"

  export default {
    name: 'ProtocolManage',
    components:{
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 协议数据
        protocalData: {
          // 分页和搜索数据
          paging: {
            page: 1,
            perPage: 10,
            protocal_name: '',
            protocal_type: '',
            direction: '',
            status: ''
          },
          // 协议列表
          list: [],
          loading: false
        }
      }
    },
    mounted(){
      this.getProtocalList()
    },
    created: async function () {
    },
    methods: {
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        let infoNull = {
          id: '' ,
          protocal_name: '',
          protocal_type: '',
          direction: '',
          prefix_char: '',
          function_code: '',
          child_function_code: '',
          data_length: '',
          bbc: '',
          desc: ''
        }
        this.dialogData = {
          type: type,
          title: type === 'add' ? '添加协议' : type === 'alter' ? '修改协议' : '',
          visible: !(this.dialogData.visible),
          isReset: false,
          info: info ? deepCopy(info) : infoNull
        }
        console.log('this', this.dialogData)
      },
      // 更新（新增/修改）协议
      updateProtocal: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id ,
          protocal_name: vm.dialogData.info.protocal_name,
          protocal_type: vm.dialogData.info.protocal_type,
          direction: vm.dialogData.info.direction,
          prefix_char: vm.dialogData.info.prefix_char,
          function_code: vm.dialogData.info.function_code,
          child_function_code: vm.dialogData.info.child_function_code,
          data_length: vm.dialogData.info.data_length,
          bbc: vm.dialogData.info.bbc,
          desc: vm.dialogData.info.desc,
          data: vm.dialogData.info.data
        }

        if (data.protocal_type === '') {
          showToast('请填写协议类型！')
          return
        }
        if (data.direction === '') {
          showToast('请填写方向！')
          return
        }
        if (data.prefix_char === '') {
          showToast('请填写前导符！')
          return
        }
        if (data.function_code === '') {
          showToast('请填写功能码！')
          return
        }
        if (data.child_function_code === '') {
          showToast('请填写子功能码！')
          return
        }
        if (data.desc === '') {
          showToast('请填写功能描述！')
          return
        }

        let res = await deviceApi.updateProtocal(data)
        if (res.meta.code === 200) {
          showToast((vm.dialogData.type === 'add' ? '添加' : '修改') + '成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getProtocalList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 修改协议状态
      changeStatus: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id
        }

        let res = await deviceApi.changeStatus(data)
        if (res.meta.code === 200) {
          showToast('修改状态成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getProtocalList()
        } else {
          showToast(res.meta.message)
        }
      }, 
      // 每页显示数量变化，获取新的协议列表
      sizeChange(val) {
        console.log(`每页 ${val} 条`);
        console.log('vm.protocalData.paging', this.protocalData.paging)
        this.getProtocalList()
      },
      // 当前页值改变，获取新的协议列表
      pageChange(val) {
        console.log(`当前页: ${val}`);
        console.log('vm.protocalData.paging', this.protocalData.paging)
        this.getProtocalList()
      },
      // 获取协议列表
      getProtocalList: async function (search) {
        let vm = this
        let data = vm.protocalData.paging
        if (search) {
          data.page = 1
        }
        
        vm.protocalData.loading = true
        let res = await deviceApi.getProtocalList(data)
        vm.protocalData.loading = false
        if (res.meta.code === 200) {
          vm.protocalData.list = res.data.list
          vm.protocalData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      // 监听搜索字段-协议名称的值变化，清空更新协议列表
      "protocalData.paging.protocal_name": function(newVal) {
        if (newVal === '') {
          this.getProtocalList()
        }
      },
      // 监听搜索字段-协议类型的值变化，清空更新协议列表
      "protocalData.paging.protocal_type": function(newVal) {
        if (newVal === '') {
          this.getProtocalList()
        }
      },
      // 监听搜索字段-方向的值变化，清空更新协议列表
      "protocalData.paging.direction": function(newVal) {
        if (newVal === '') {
          this.getProtocalList()
        }
      },
      // 监听搜索字段-状态的值变化，清空更新协议列表
      "protocalData.paging.status": function(newVal) {
        if (newVal === '') {
          this.getProtocalList()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.searchBox {
  width: 100%;
  .searchInput,
  .searchBtn {
    float: left;
    height: 40px;
    margin-bottom: 20px;
  }
  .searchInput {
    width: 200px;
    margin-right: 2%;
  }
  .searchBtn {
    margin-left: 2%;
  }
}
.addButton {
}
.updataForm {
  .hint {
    color: #909399;
    display: block;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/DeviceManage/ProtocolManage.vue